import type { PrivateEnvConfig } from "@/types/env-config";

const brand = window.__ENV_CONFIG__.serve.area;
const deployEnv = window.__ENV_CONFIG__.deployEnv;

let config = {} as PrivateEnvConfig;

if (deployEnv === "dev" || deployEnv === "local") {
  config = {
    firebase: {
      apiKey: "AIzaSyByeITG6BbZdeXdXgJrxLkusA1-zerStiQ",
      cloudMessagingVapidKey: "BJx8osRcJDfhsa7Eb24FO8x8hjjfMLmHIN1jn3prOGSB9mGsmfehELbeFwcUBt1odiuFNWFO0vSSaGpUSukttrw",
    },
    encryption: {
      aesKey: "J1CjogdqPhkYtsAQ",
      aesIv: "io9AZNwWmdGPRx9A",
    },
    dynamicConfig: {
      aesKey: "fd4e0v112ebc9f26",
      aesIv: "9d7e2v45f9e2a8c7",
    },
    directus: {
      apiToken: "3R_XoGYdpn9BwWTHvW2NWa3JiKnviioI",
    },
  };
} else if (deployEnv === "uat") {
  config = {
    firebase: {
      apiKey: "AIzaSyDvZs7O2gBQ-OeOc4zeEJ2Y6bWkoDhwqns",
      cloudMessagingVapidKey: "BNzSqwVtSquEtAEEzGZJZOVsjrkipCFIiUZ7biupqlcaGC5vaFE16KTP8QsFFSu2wfOYn86v2EiVPlcyupr1ASs",
    },
    encryption: {
      aesKey: "J1CjogdqPhkYtsAQ",
      aesIv: "io9AZNwWmdGPRx9A",
    },
    dynamicConfig: {
      aesKey: "fd4e0v112ebc9f26",
      aesIv: "9d7e2v45f9e2a8c7",
    },
    directus: {
      apiToken: "3R_XoGYdpn9BwWTHvW2NWa3JiKnviioI",
    },
  };
} else if (brand === "cn") {
  config = {
    firebase: {
      apiKey: "AIzaSyAA4pWvYxwtqS9hTQCmILmeuvizk2aQHCs",
      cloudMessagingVapidKey: "BDNhspvEdO2Pi2gIe37Oxth_8ShHmxW013IlekAR4iBewm2isgl_FtiRrFcyL15xRn8_V1NNiB_vIFf2eSMXeoY",
    },
    encryption: {
      aesKey: "J1CjogdqPhkYtsAQ",
      aesIv: "io9AZNwWmdGPRx9A",
    },
    dynamicConfig: {
      aesKey: "fp4r0d112ebc9f26",
      aesIv: "9p7r2d45f9e2a8c7",
    },
    directus: {
      apiToken: "7aC3kH10s6eAMwuilh0DZM0EPBz7j8nU",
    },
  };
} else if (brand === "hcm") {
  config = {
    firebase: {
      apiKey: "AIzaSyC-IkLbTS3WcRy9sLKYn55H27xBKsOW5EY",
      cloudMessagingVapidKey: "BJzNyC7X4lHLeZKB6lf7vZ_yPssCxtBV3nvB9KUN8qlJ3XluMw4UVhiHF6aVwMOewf-cTBLNVOeCYpJGZ8rXBEY",
    },
    encryption: {
      aesKey: "J1CjogdqPhkYtsAQ",
      aesIv: "io9AZNwWmdGPRx9A",
    },
    dynamicConfig: {
      aesKey: "fp4r0d112ebc9f26",
      aesIv: "9p7r2d45f9e2a8c7",
    },
    directus: {
      apiToken: "0wx3yin3R7emWouOa6cFRw9vDADCFEuL",
    },
  };
} else if (brand === "mo") {
  config = {
    firebase: {
      apiKey: "AIzaSyBW_qcGH37gWIu1275XmGRTGY4j837Wd2E",
      cloudMessagingVapidKey: "BN1_M9xDgsJwYQRGwy3i-zfGuOzRKtZxXmKsLTZit48oor-2M-zZaea3EZrFSx943obE-2SUFd7WpIEBvFRgSeA",
    },
    encryption: {
      aesKey: "J1CjogdqPhkYtsAQ",
      aesIv: "io9AZNwWmdGPRx9A",
    },
    dynamicConfig: {
      aesKey: "fp4r0d112ebc9f26",
      aesIv: "9p7r2d45f9e2a8c7",
    },
    directus: {
      apiToken: "A7PwVtYbVDjNOvJ0IULLDExagP89QpZu",
    },
  };
}

export default config;
